// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__3l6Az","clickedWithMouse":"MenuLabel_clickedWithMouse__29FBf","isOpen":"MenuLabel_isOpen__1Kdky"};